export function useCustomToasts() {
  const toast = useToast();

  const config = { group: 'br' };

  const success = (detail: string) => {
    toast.add({ ...config, life: 2000, severity: 'success', detail });
  };

  const error = (detail: string) => {
    toast.add({ ...config, life: 4000, severity: 'error', detail });
  };

  return { success, error };
}
